import type { ISegment } from "@repo/baseCloud";

import { Checkbox, TextBox } from "@repo/ui";
import { useCallback } from "react";

import { SegmentFilters } from "../../../components/segmentFilters";
import { useMapSettings } from "../hooks";
import { useMapFilters } from "./filterContext";

export function LiveViewMapFilters() {
	const { filters, setFilters, filterChanged } = useMapFilters();
	const mapSettingsQuery = useMapSettings();

	const segmentChanged = useCallback(
		(segFilters: ISegment) => setFilters((prev) => ({ ...prev, ...segFilters })),
		[setFilters],
	);

	return (
		<>
			<SegmentFilters onChange={segmentChanged} value={filters} />
			<Checkbox
				id="retailLocations"
				label={"Show Retail Locations"}
				value={filters.retailLocations}
				changeHandler={filterChanged}
				inline
				hidden={!mapSettingsQuery.data?.canShowRetailLocations}
			/>
			<TextBox
				label="Last Updated Within Hours"
				id="limitToLastHours"
				value={filters.limitToLastHours}
				changeHandler={filterChanged}
			/>
		</>
	);
}
